module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kj-La.f79b0876.png";